export default "__VITE_ASSET__477058dc__"